import { Pipe, PipeTransform } from '@angular/core';
import { getAssetsUrl } from './assets-url';

@Pipe({
    name: 'assetsUrl'
})
export class AssetsUrlPipe implements PipeTransform {

    transform(path: string): string {
        return getAssetsUrl(path);
    }
}